import {Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {FormComponent} from 'lf-at-theme';
import {INITIAL_VALUES, UnionInitialValues} from '../tokens';
import {reactionCommencementDate} from '../../common/form-reactions';
import { autorun } from "mobx"

@Component({
  selector: 'app-union-form',
  templateUrl: './union-form.component.html',
  styleUrls: ['./union-form.component.scss']
})
export class UnionFormComponent implements OnInit, AfterViewInit {

  @ViewChild('form') _lfForm: FormComponent;

  constructor(@Inject(INITIAL_VALUES) public initialValues: UnionInitialValues) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    autorun(() => {
      reactionCommencementDate(this._lfForm);
    })

  }

  get hasCadastroData() {
    return this.initialValues.hasCadastroData;
  }

  showExtraAddressFields(address): boolean {
    return address.suite
      || address.postOfficeBox
      || address.district
      || address.countrySubEntity
      || address.otherLocalId;
  }
}
